<template>
  <div class="xml-tag whitespace-nowrap w-full">
    <div v-if="isOnlyText" class="xml-line">
      <span class="xml-symbol">&lt;</span>
      <span class="xml-tag-name">{{ xmlNode.tagName }}</span>
      <span v-for="(value, name) in attributes" :key="name" class="xml-attr">&nbsp;{{ name }}="<span class="xml-attr-value">{{ value }}</span>"</span>
      <span class="xml-symbol">&gt;</span>
      <span class="xml-text">{{ childNodes[0].textContent.trim() }}</span>
      <span class="xml-symbol">&lt;/</span>
      <span class="xml-tag-name">{{ xmlNode.tagName }}</span>
      <span class="xml-symbol">&gt;</span>
    </div>
    <template v-else>
      <div class="xml-wrap">
        <base-icon-clickable
          v-if="hasElementChildren"
          style="color: var(--primary-DEFAULT);"
          class="expand-icon flex"
          :class="{ 'rotate-180': expanded }"
          size="xsm"
          name="arrowup"
          @click="toggleExpand"
        />
        <div class="xml-line cursor-pointer" @click="toggleExpand">
          <span class="xml-symbol">&lt;</span>
          <span class="xml-tag-name">{{ xmlNode.tagName }}</span>
          <span v-for="(value, name) in attributes" :key="name" class="xml-attr">&nbsp;{{ name }}="<span class="xml-attr-value">{{ value }}</span>"</span>
          <span class="xml-symbol">&gt;</span>
        </div>
      </div>

      <div v-if="expanded" class="xml-children">
        <template v-for="(node, index) in childNodes">
          <xml-tag
            v-if="node.nodeType === 1"
            :key="'el-' + index"
            :xml-fragment="node"
          />
          <span
            v-else-if="node.nodeType === 3 && node.textContent.trim()"
            :key="'text-' + index"
            class="xml-text"
          > {{ node.textContent.trim() }} 
          </span>
        </template>
      </div>
      <div v-else class="xml-collapsed">...</div>

      <div class="xml-line xml-end-line">
        <span class="xml-symbol">&lt;/</span>
        <span class="xml-tag-name">{{ xmlNode.tagName }}</span>
        <span class="xml-symbol">&gt;</span>
      </div>
    </template>
  </div>
</template>


<script>
export default {
  name: 'xml-tag',
  props: {
    xmlFragment: {
      type: [String, Node, Element],
      required: true,
    },
  },
  data () {
    return {
      expanded: true
    }
  },
  computed: {
    xmlNode () {
      if (typeof this.xmlFragment === 'string') {
        const parser = new DOMParser()
        const doc = parser.parseFromString(this.xmlFragment, 'text/xml')
        return doc.documentElement
      }
      return this.xmlFragment
    },
    childNodes () {
      return Array.from(this.xmlNode?.childNodes || [])
    },
    hasElementChildren () {
      return this.childNodes.some(node => node.nodeType === 1)
    },
    isOnlyText () {
      return this.childNodes.length === 1 && this.childNodes[0].nodeType === 3
    },
    attributes () {
      const attrs = {}
      Array.from(this.xmlNode.attributes).forEach(attr => {
        attrs[attr.name] = attr.value
      })
      return attrs
    },
    strNode () {
      return this.serializeNode(this.xmlNode)
    }
  },
  methods: {
    toggleExpand () {
      if (this.hasElementChildren) {
        this.expanded = !this.expanded
      }
    },
    serializeNode (node) {
      return new XMLSerializer().serializeToString(node)
    }
  }
}
</script>

<style lang="scss" scoped>
.xml-tag {
  .xml-line {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    max-width: 100%;
    overflow-wrap: break-word;
  }

  .xml-wrap {
    display: flex;
    align-items: flex-start;
    gap: .3rem;

    .expand-icon {
      margin-top: .15rem;
      width: .5rem;
    }
  }

  .xml-children {
    padding-left: 1rem;
  }

  .xml-collapsed {
    padding-left: 1rem;
    margin-left: 1rem;
    color: var(--primary-DEFAULT);
  }

  .xml-tag-name, .xml-symbol {
    color: var(--primary-900);
  }

  .xml-attr {
    // display: flex;
    color: var(--primary-600);
    /* padding: 0px 0.3rem; */

    .xml-attr-value {
      color: var(--darkblue-500);
      // width: 100%;
    }
  }

  .xml-text {
    color: var(--primary-DEFAULT);
    width: fit-content;
    padding: 0px 0.3rem;
    // text-wrap: auto;
  }

  &:has(.expand-icon) {
    > .xml-end-line {
      margin-left: 1.3rem;
    }
  }

  .xml-tag:not(:has(.expand-icon)) {
    padding-left: 1rem;
  }
}

.dark {
  .xml-tag {
    .xml-tag-name, .xml-symbol {
      color: var(--darkblue-100);
    }
  
    .xml-attr {
      color: var(--primary-200);

      .xml-attr-value {
        color: var(--darkblue-300);
      }
    }
  
    .xml-collapsed {
      color: var(--primary-400);
    }
  
    .xml-text {
      color: var(--primary-400);
    }
  }
}
</style>
